<template>
    <div class="paper_move_to_folder_wrp">
        <div class="paper_move_to_folder_center">
            <div class="paper_move_to_folder_main">
                <div class="paper_move_to_folder_header">
                    <h3 class="paper_move_to_folder_heading">Paper Move</h3>
                    <i class="fa fa-times" @click="paperMoverPopupClosed"></i> 
                </div>
                <div class="paper_move_to_folder_body">
                    <div class="paper_move_to_folder_to_list_wrp">
                        <template v-if="bucketListResults.length > 0">
                            <bucket-tree-view :tree-data="bucketListResults"
                                :ParentDirectory="parentDirectory"></bucket-tree-view>
                        </template>
                        <template v-else>
                            <p class="text-center mt-4">You don't have any shelf</p>
                        </template>
                    </div>
                    <div class="apply_btn_wrp" v-if="selectMoveFolderId">
                        <button class="btn btn-primary" @click="movePaperInParentFolder" :disabled="isSubmitted">Apply
                            Changes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');

import bucketTreeView from './tree-view-bucket.vue';
import {
    bus
} from '@/main';
import {
    mapGetters,
} from 'vuex';
import toast from '@/services/toast';

export default {
    name: 'paper-move-to-folder',
    components: {
        'bucket-tree-view': bucketTreeView
    },
    props: ['paperMoverToFolderDATA'],
    data() {
        return {
            bucketListDetails: null,
            bucketListResults: [],
            selectPaperMoverToFolderData: null,
            selectMoveFolderId: '',
            isSubmitted: false,
            parentDirectory: ''
        }
    },
    computed: {
        ...mapGetters([
            'getBucketListOfAwerackGetters',
        ]),
        getBucketListDetailsFun() {
            this.bucketListDetails = this.$store.getters.getBucketListOfAwerackGetters.data;
            return;
        },
        setIntialStateOfBucket() {
            if (this.bucketListDetails) {
                this.bucketListResults = this.bucketListDetails.results
            }
        }
    },
    mounted() {
        this.parentDirectory = this.paperMoverToFolderDATA.parent_directory
        this.selectPaperMoverToFolderData = this.paperMoverToFolderDATA
        this.getBucketListDetailsFun
        this.setIntialStateOfBucket
        bus.$on('getSelectFolderID', (data) => {
            this.selectMoveFolderId = data
        })
    },
    methods: {
        getPaperPileListAgain() {
            this.$store.dispatch('getAllPaperPileFun')
        },
        movePaperInParentFolder() {
            this.isSubmitted = true
            let payload = {
                parent: this.selectMoveFolderId,
                pdf_paper: this.selectPaperMoverToFolderData.id,
                is_folder: false
            }
            this.$store.dispatch('createBucketOfAwerackDetailsFun', payload).then((res) => {
                this.isSubmitted = false
                this.getPaperPileListAgain()
                this.paperMoverPopupClosed()
                toast.success(res.data.msg);
            }).catch((err) => {
                this.isSubmitted = false
                this.paperMoverPopupClosed()
                toast.error(err.data.user_msg || err.data.msg);
            })
            return;
        },
        paperMoverPopupClosed() {
            bus.$emit('paperMoverToFolderBus', false)
            $('body').removeClass('body_right_scroll_remove')
        }
    },
    watch: {
        getBucketListDetailsFun() {
            return this.$store.getters.getBucketListOfAwerackGetters
        },
        setIntialStateOfBucket() {
            if (this.bucketListDetails) {
                this.bucketListResults = this.bucketListDetails.results
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.paper_move_to_folder_wrp {
    position: fixed;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.92);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    .paper_move_to_folder_center {
        height: 100%;
        display: flex;
        width: 100%;
        align-items: center;
        padding: 0 15px;
    }

    .paper_move_to_folder_main {
        background: #000;
        max-width: 440px;
        width: 100%;
        margin: 0 auto;
        border-radius: 5px;
        box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    }
    .paper_move_to_folder_header{
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        padding: 14px 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .fa {
            font-size: 20px;
            color: red;
            cursor: pointer;
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -webkit-transition: all ease 0.5s;
            transition: all ease 0.5s;
            &:hover{
                    color: #87cefa;
            }
        }

        .paper_move_to_folder_heading {
            color: #ffffff;
            margin: 0;
            font-size: 22px;
        }

    }
    .paper_move_to_folder_body{padding:10px 25px;}
    .paper_move_to_folder_to_list_wrp {
        height: 300px;
        overflow-y: auto;
        padding-bottom:15px;

        &::-webkit-scrollbar {
            width: 4px;
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #333333;
        }
    }

    .paper_move_to_folder_to_list {
        .paper_move_to_folder_to_list_item {
            padding: 0px 15px;
        }

        label {
            display: flex;
            align-items: center;
            cursor: pointer;
            margin: 0px;
        }

        .paper_move_to_folder_avtaar {
            padding: 5px 10px;

            img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
            }
        }

        .paper_move_to_folder_info {
            span {
                display: block;
            }

            .paper_move_to_folder_name {
                line-height: 1;
                font-size: 16px;
                margin-bottom: 3px;
                color: #fff;
            }

            .paper_move_to_folder_email {
                font-size: 15px;
                color: rgba(255, 255, 255, 0.5);
                white-space: pre-wrap;
                word-break: break-all;
            }
        }
    }

    .paper_move_to_folder_searchbar_new_chat {
        padding: 10px;
        background: #1d2226;
        border-bottom: 1px solid #171b1f;

        .search_for_new_chat_inner {
            position: relative;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 80px;
            padding: 0;

            .back {
                display: none;
                position: absolute;
                left: 0px;
                top: 50%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                cursor: pointer;
            }

            .search {
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
            }

            .x-alt {
                position: absolute;
                right: 15px;
                top: 50%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                cursor: pointer;

                .img-fluid {
                    width: 15px;
                }
            }

            .form-control {
                background: none;
                border: none;
                color: #ffffff;
                padding: 8px 45px;
                line-height: 1;
                height: auto;
                font-size: 16px;
                outline: none;
                box-shadow: none;

                &::-moz-placeholder {
                    color: rgba(255, 255, 255, 0.6);
                }

                &::-webkit-input-placeholder {
                    color: rgba(255, 255, 255, 0.6);
                }

                &:focus::-webkit-input-placeholder {
                    font-size: 0;
                }

                &:focus::-moz-placeholder {
                    font-size: 0;
                }
            }

            .x-alt.search_disabled_btn {
                display: block;
            }
        }

        &.search_enabled,
        &.searching_enabled {
            background: rgba(255, 255, 255, 0.1);

            .search_for_new_chat_inner {
                background: none;

                .search {
                    display: none;
                }

                .back {
                    display: block;
                }
            }
        }
    }

    .msg_forward_btn_wrp {
        background: #87cefa;
        color: #000;
        padding: 3px 15px;
        border-radius: 0px 0px 5px 5px;
        position: absolute;
        width: 100%;
        bottom: 0;

        .msg_forward_to_selcted_wrp {
            padding: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 85%;
            margin: 0px;

            li {
                font-size: 16px;
                margin-right: 5px;

                &:last-child i {
                    display: none;
                }

                display:inline-block;
            }
        }

        .btn-success {
            padding: 5px 10px;
            position: absolute;
            top: -20px;
            right: 8px;
            outline: none;
            box-shadow: none;
        }
    }

    .forward_popup_body {
        position: relative;
    }

    .apply_btn_wrp {
        text-align: center;

        .btn-primary {
            width: 100%;
            background: none;
            color: #ffd400;
            border-radius: 5px;
            padding: 10px 0;
            outline: none;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            border: 2px solid #ffd400;

            &:hover {
                background: #ffd400;
                color: #22292f;
            }
        }
    }
}
</style>